// extracted by mini-css-extract-plugin
export default {"banner":"Hba","mobileImage":"Iba","deskimg":"Jba","desktopImage":"Kba","wrapper":"Lba","text":"Mba","text_wrapper":"Nba","breadContain":"Oba","systemWrapper":"Pba","system":"Qba"};
    if(module.hot) {
      // 1738836199105
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  